import Vue from "vue"
import Vuex from "vuex"

import { auth } from "./modules/Auth"
import portal from "./modules/Portal"
import evaluation from "./modules/Evaluation"
import doctorSearch from "./modules/DoctorSearch"
import doctorRegistration from "./modules/DoctorRegistration"
import doctors from "./modules/List_Doctors"
import patientRegistration from "./modules/PatientRegistration"
import reports from "./modules/List_Reports"
import reportPreview from "./modules/ReportPreview"
import screenings from "./modules/List_Screenings"
import patients from "./modules/List_Patients"
import telemedicine from "./modules/Telemedicine"
import imagePicker from "./modules/ImagePicker"
import DxCards from "./modules/DxCards"
import organizations from "./modules/List_Organizations"
import devices from "./modules/Devices"
import admins from "./modules/Admins"
import doctorsManagement from "./modules/Doctors"
import readers from "./modules/Readers"
import technicians from "./modules/Technicians"
import patientsManagement from "./modules/PatientsManagement"
import lookup from "./modules/Lookup.js"
import readerRegistration from "./modules/ReaderRegistration"
import adminRegistration from "./modules/AdminRegistration"
import doctorProfile from "./modules/DoctorProfile"
import masterData from "./modules/masterData"
import mgmtUsers from "./modules/mgmtUsers"

Vue.use(Vuex)

export default new Vuex.Store({
  name: "store",
  modules: {
    auth,
    portal,
    doctors,
    reports,
    evaluation,
    screenings,
    reportPreview,
    doctorSearch,
    doctorRegistration,
    patientRegistration,
    doctorProfile,
    readerRegistration,
    adminRegistration,
    telemedicine,
    imagePicker,
    DxCards,
    patients,
    patientsManagement,
    organizations,
    devices,
    doctorsManagement,
    readers,
    technicians,
    admins,
    lookup,
    masterData,
    mgmtUsers
  },
  getters: {
    isPhone() {
      if (window.screen.width < 760) {
        return true
      } else {
        return false
      }
    }
  }
})
